import { render, staticRenderFns } from "./SupplierSmtpConfig.vue?vue&type=template&id=4fb74094&scoped=true&"
import script from "./SupplierSmtpConfig.vue?vue&type=script&lang=js&"
export * from "./SupplierSmtpConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb74094",
  null
  
)

export default component.exports